import React from "react";
import { Alignment, Side, Size } from "../../types/system/Layout";
import Utilities from "../../foundation/Utility";

import "./Info.scss";

interface InfoProps {
    children?: any;
    className?: string;

    clearanceSide?: Side;
    clearanceSize?: Size;

    bufferSide?: Side;
    bufferSize?: Size;

    alignment?: Alignment;
}

class Info extends React.Component<InfoProps> {
    render(): React.ReactNode {
        let classNames = this.props.className ? ` ${this.props.className}` : "";

        // Clearance classes
        if (!!this.props.clearanceSide) {
            classNames += ` ${Utilities.getSideClass(
                this.props.clearanceSide,
            )}clearance${Utilities.getSizeClass(this.props.clearanceSize)}`;
        }

        // Buffer classes
        if (!!this.props.bufferSide) {
            classNames += ` ${Utilities.getSideClass(
                this.props.bufferSide,
            )}buffer${Utilities.getSizeClass(this.props.bufferSize)}`;
        }

        // Alignment classes
        if (!!this.props.alignment) {
            classNames += ` text-${this.props.alignment}`;
        }

        return <div className={`info-container${classNames}`}>{this.props.children}</div>;
    }
}

export default Info;
